export const COURSE_DETAIL_AMPLITUDE_PAGE_NAME = 'Course Detail';
export const COURSE_DETAIL_PAGE_KEY = 'org-course-detail';

export enum LEARNING_COURSE_DETAIL_FEATURE_FLAGS {
  LEARNING_COURSE_RESTRICTION_RULES = 'LEARNING_COURSE_RESTRICTION_RULES',
  LEARNING_KNOWLEDGEHUB_COLLABORATOR_V2 = 'LEARNING_KNOWLEDGEHUB_COLLABORATOR_V2',
}
